import { observable } from 'mobx';
import { fetchSalaryNum, fetchSalaryList, fetchTaskDetailInfo } from '@/services/salary';

// 我的佣金信息
const salary = observable({
  settledAmt: 0, // 已结算合计
  unsettledAmt: 0, // 带结算合计
  salaryList: [], // 任务结算列表
  pageNum: 0,
  taskDetail: {
    taskTitle: '',
    taskContent: '',
  },
  // 获取结算记录信息
  async getListInfo(payload) {
    const { pageNum, totalPages, item } = await fetchSalaryList(payload);
    this.totalPages = totalPages;
    this.pageNum = pageNum;
    this.salaryList = pageNum === 1 ? item : [].concat(this.salaryList, item || []);
  },
  // 清空结算记录信息
  async clearListInfo() {
    this.totalPages = undefined;
    this.pageNum = 1;
    this.salaryList = [];
  },
  // 获取佣金合计信息
  async getSettledInfo(payload) {
    const { settledAmt, unsettledAmt } = await fetchSalaryNum(payload);
    this.settledAmt = settledAmt;
    this.unsettledAmt = unsettledAmt;
  },
  // 查询任务详情
  async getTaskDetailInfo(payload) {
    const { taskTitle, taskContent } = await fetchTaskDetailInfo(payload);
    this.taskDetail = {
      taskTitle,
      taskContent
    };
  },
});

export default salary;
